import React, { useMemo } from 'react';
import cs from 'classnames';
import styles from './LoadingDots.module.scss';
export default function LoadingDots(_ref) {
  var size = _ref.size;
  var _useMemo = useMemo(function () {
      if (size === 'small') {
        return {
          cx1: '4',
          cx2: '12',
          cx3: '20',
          cy: '4',
          height: 8,
          width: 28
        };
      }
      return {
        cx1: '9',
        cx2: '33',
        cx3: '57',
        cy: '9',
        height: 18,
        width: 66
      };
    }, [size]),
    cx1 = _useMemo.cx1,
    cx2 = _useMemo.cx2,
    cx3 = _useMemo.cx3,
    cy = _useMemo.cy,
    height = _useMemo.height,
    width = _useMemo.width;
  return /*#__PURE__*/React.createElement("svg", {
    className: "_dm-loading-dots",
    height: height,
    width: width,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cs(styles.circle, styles["dot1--".concat(size)]),
    cx: cx1,
    cy: cy,
    r: cy
  }), /*#__PURE__*/React.createElement("circle", {
    className: cs(styles.circle, styles["dot2--".concat(size)]),
    cx: cx2,
    cy: cy,
    r: cy
  }), /*#__PURE__*/React.createElement("circle", {
    className: cs(styles.circle, styles["dot3--".concat(size)]),
    cx: cx3,
    cy: cy,
    r: cy
  }));
}